// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".invoice-upload[data-v-f687806e] {\n  width: 100%;\n}\n.invoice-upload[data-v-f687806e]  .el-upload,\n.invoice-upload[data-v-f687806e]  .el-upload-dragger {\n  width: 100%;\n}", ""]);
// Exports
module.exports = exports;
